import React from 'react';
import styled from '@emotion/styled';

export const Container = styled.div`
    display: flex;
    align-items: center;
    flex: 1;
`;

const Content = styled.div`
    width: 100%;
`;

export const VerticalAligned: React.FC = ({ children }) => {
    return (
        <Container>
            <Content>{children}</Content>
        </Container>
    );
};
